import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-question-answer-fill"></i>
              常见问题
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于阅读，你可能想问
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              这里整理了关于阅读模式、夜间模式、进度同步与加载体验的常见疑问，如果没有找到答案，也欢迎在页脚反馈建议。
            </p>
            <a
              href="#guide"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看阅读指南 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-lg border transition-colors ${
                    isOpen ? "border-primary-200 bg-primary-50/50" : "border-background-200 bg-background-50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`}></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}